<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss" src="./assets/sass/main.scss">
</style>



// WEBPACK FOOTER //
// src/App.vue